import request from '../request'

//公务车使用申请列表
export const car_use_index_request = p => {
    return request({
        method:'GET',
        url:'car_use/index',
        params: p
    })
}

//新增公务车使用申请
export const car_use_add_request = d => {
    return request({
        method:'POST',
        url:'car_use/add',
        data: d
    })
}

//删除公务车使用申请
export const car_use_del_request = id => {
    return request({
        method:'DELETE',
        url:'car_use/del',
        data: {
            id: id
        }
    })
}

//修改公务车使用申请
export const car_use_edit_request = data => {
    return request({
        method:'PUT',
        url:'car_use/edit',
        data
    })
}

//公务车使用申请详情
export const car_use_details_request = id => {
    return request({
        method:'GET',
        url:'car_use/details',
        params: {
            id
        }
    })
}

// 提交公务车使用申请
export const car_use_to_approval_request = d => {
    return request({
        method:'PUT',
        url:'car_use/to_approval',
        data: {
            id:d.id,
            note:d.note
        }
    })
}

// 查看公务车使用申请审批记录
export const car_use_sel_approval_request = id => {
    return request({
        method:'GET',
        url:'car_use/sel_approval',
        params: {
            id
        }
    })
}

// 审批公务车使用申请
export const car_use_approval_request = d => {
    return request({
        method:'PUT',
        url:'car_use/approval',
        data: {
            id: d.id,
            opinion: d.opinion,
            note: d.note,
            other: d.other,
            go_staff_id: d.go_staff_id
        }
    })
}

// 撤回公务车使用申请
export const car_use_withdraw_request = d => {
    return request({
        method:'PUT',
        url:'car_use/withdraw',
        data: {
            id: d.id
        }
    })
}

// 打印公务车使用申请
export const car_use_print_request = id => {
    return request({
        method:'PUT',
        url:'car_use/print',
        data: {
            id
        }
    })
}

// 补充公务车使用申请附件
export const car_use_add_file_request = data => {
    return request({
        method:'PUT',
        url:'car_use/add_file',
        data
    })
}